module.exports = __webpack_public_path__ + "img/pt.ec536776.svg";